import React from 'react';
import {Navigate, Route, Routes} from 'react-router';
import type {NoProps} from 'types';
import {Configuration, isFeatureEnabled} from 'configuration';
import {BulkUpdateNewScene} from 'scenes/bulkUpdateNew';
import {DebugScene} from 'scenes/debug';
import {
  AdvancedSearchScene,
  AgentEditScene,
  AgentsScene,
  BulkUpdateDetailsScene,
  BulkUpdateListScene,
  DemoScene,
  EanToWorkRedirect,
  Login,
  LoginCallback,
  Logout,
  LogoutCallback,
  OverviewScene,
  PrizeEditScene,
  PrizesScene,
  ReceiveScene,
  SearchMetadataScene,
  StatisticsScene,
  ThemeShowcaseScene,
  UpdateLogScene,
  UpdateMetadataScene,
} from '../scenes';
import {MergeAgentsScene} from '../scenes/mergeAgents';
import {MergeSeriesScene} from '../scenes/mergeSeries';
import {MergeSuggestionsScene} from '../scenes/mergeSuggestions';
import {MergeWorkScene} from '../scenes/mergeWork';
import {ShortcutsScene} from '../scenes/shortcuts/ShortcutsScene';
import App from './App';

type Props = NoProps;

export const AppRoutes: React.FC<Props> = () => {
  return (
    <Routes>
      <Route path="/logout" element={<Logout />} />
      <Route path="/logout/callback" element={<LogoutCallback />} />
      <Route path="/login/:redirect?" element={<Login />} />
      <Route path="/login/callback" element={<LoginCallback />} />
      <Route path="/" element={<App />}>
        <Route index element={<Navigate to={'overview'} />} />
        <Route path="overview" element={<OverviewScene />} />
        {isFeatureEnabled('advancedSearch') ? (
          <Route path="search" element={<AdvancedSearchScene />} />
        ) : null}
        <Route path="statistics" element={<StatisticsScene />} />
        <Route path="metadata" element={<SearchMetadataScene />} />
        <Route path="metadata/:workId" element={<UpdateMetadataScene />} />
        <Route path="metadata/ean/:ean" element={<EanToWorkRedirect />} />
        <Route path="agent" element={<AgentsScene />} />
        <Route path="agent/:agentId" element={<AgentEditScene />} />
        {isFeatureEnabled('prizes') ? (
          <Route path="prize" element={<PrizesScene />} />
        ) : null}
        {isFeatureEnabled('prizes') ? (
          <Route path="prize/:prizeId" element={<PrizeEditScene />} />
        ) : null}

        <Route path="mergeOverview" element={<MergeSuggestionsScene />} />
        <Route
          path="series/:sourceId/merge/:targetId"
          element={<MergeSeriesScene />}
        />
        <Route
          path="agent/:sourceId/merge/:targetId"
          element={<MergeAgentsScene />}
        />
        <Route
          path="work/:sourceId/merge/:targetId"
          element={<MergeWorkScene />}
        />

        <Route path="receive" element={<ReceiveScene />} />
        <Route path="bulkUpdate" element={<BulkUpdateListScene />} />
        <Route
          path="bulkUpdate/details/:bulkUpdateId"
          element={<BulkUpdateDetailsScene />}
        />
        <Route path="bulkUpdate/new" element={<BulkUpdateNewScene />} />
        <Route path="updateLog" element={<UpdateLogScene />} />
        <Route path="shortcuts" element={<ShortcutsScene />} />
        {Configuration.env === 'local' || Configuration.env === 'dev' ? (
          <>
            <Route path="demo" element={<DemoScene />} />
            <Route path="theme" element={<ThemeShowcaseScene />} />
          </>
        ) : null}
      </Route>
      <Route path="debug" element={<DebugScene />} />
    </Routes>
  );
};
